import Handler from "@/core/domain/usecase/handler"

const CreateServiceOrderReportImageRepository = (axios) => async (data) => {
    try {
        const response = await axios.post(`/service-order-report-image`, data)
        
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default CreateServiceOrderReportImageRepository